import { Flex } from '@billy/design-system'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'
import { useInvoiceEditorVariant } from '../../hooks/useInvoiceEditorVariant'
import { RelatedDocumentSubtitle } from './elements/RelatedDocumentSubtitle'
import { getInvoiceEditorTitle } from './utils/getInvoiceEditorTitle'

const variantsWithRelatedDocumentSubtitle = [
  InvoiceEditorVariant.DepositInvoiceDraftEdit,
  InvoiceEditorVariant.DepositInvoiceNewFromQuote,
  InvoiceEditorVariant.FinalInvoiceDraftEdit,
  InvoiceEditorVariant.FinalInvoiceNewFromQuote,
  InvoiceEditorVariant.InvoiceDraftEdit,
  InvoiceEditorVariant.InvoiceNewFromQuote,
]

export const InvoiceEditorTitle = (): string | ReactElement => {
  const { t } = useTranslation()
  const { invoiceEditorVariant } = useInvoiceEditorVariant()

  const title = getInvoiceEditorTitle(invoiceEditorVariant, t)

  if (!variantsWithRelatedDocumentSubtitle.includes(invoiceEditorVariant)) {
    return title
  }

  return (
    <Flex flexDirection="column">
      {title}
      <RelatedDocumentSubtitle />
    </Flex>
  )
}
